// extracted by mini-css-extract-plugin
module.exports = {"syn-button":"syn-button-77c190c25c206429e2103d272b5b93fa"};